<div class="dialog-body">
  <ng-container [ngComponentOutlet]="component" [ngComponentOutletInputs]="inputParams" />
</div>
